import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/artstation': {
    width: 508,
    height: 512,
    paths: [
      {
        d: 'M0 377.4L43 451.7C51.5 468.5 68.8 480 88.9 480H374.3L315.1 377.4H0zM499.8 350L333.6 59.3C325 43.1 307.9 32 288.2 32H199.8L457.1 479.6 497.8 409.1C499.7 405.9 518.8 379.4 499.8 350zM273 304.5L157.5 104.5 42 304.5H273z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/artstation.js
// module id = 1lAX
// module chunks = 144